import { render, staticRenderFns } from "./QxHome.vue?vue&type=template&id=d0cfde0c&scoped=true"
import script from "./QxHome.vue?vue&type=script&lang=js"
export * from "./QxHome.vue?vue&type=script&lang=js"
import style0 from "./QxHome.vue?vue&type=style&index=0&id=d0cfde0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cfde0c",
  null
  
)

export default component.exports